/* eslint-disable max-len */
/* eslint-disable no-unused-vars */

const SAL_BENCHMARK_ID_MIX = 'mstarorcat';
const SAL_BENCHMARK_ID_PRIMARY_PROSPECTUS = 'prospectus_primary';
const SAL_CONTENT_TYPE_BASIC = '';
const SAL_CONTENT_TYPE_PREMIUM = 'nNsGdN3REOnPMlKDShOYjlk6VYiEVLSdpfpXAm7o2Tk=';
const NO_MIP_ANALYSIS_EDITIONS = ['ja'];
const NO_EQSV_SUSTAINABILITY_EDITIONS = ['ja'];
const NO_PARENT_PILLAR_CARDS_EDITIONS = ['ja'];

const APP = {
	API_PLATFORM_URL: 'https://indiv-api-stg.morningstar.com',
	EDITION_BENELUX: 'nl',
	EDITION_CANADA_ENGLISH: 'en-ca',
	EDITION_CANADA_FRENCH: 'fr-ca',
	EDITION_DEUTCHLAND: 'de',
	EDITION_EUROPE: 'en-eu',
	EDITION_FRANCE: 'fr',
	EDITION_ITALY: 'it',
	EDITION_JAPAN: 'ja',
	EDITION_SPAIN: 'es',
	EDITION_UNITED_KINGDOM: 'en-gb',
	SECURITY_TYPES: {
		cef: {
			benchmarkId: SAL_BENCHMARK_ID_MIX,
			contentType: SAL_CONTENT_TYPE_PREMIUM,
			id: 'cef',
			path: '/cefs',
			securityId: 'FCUSA00071', // Nuveen Municipal Value Fund (NUV)
			securityType: 'FC'
		},
		etf: {
			benchmarkId: SAL_BENCHMARK_ID_PRIMARY_PROSPECTUS,
			contentType: SAL_CONTENT_TYPE_PREMIUM,
			id: 'etf',
			path: '/etfs',
			securityId: 'FEUSA04AC5', // Vanguard Growth Index Fund ETF Shares (VUG)
			securityType: 'FE'
		},
		fund: {
			benchmarkId: SAL_BENCHMARK_ID_MIX,
			contentType: SAL_CONTENT_TYPE_PREMIUM,
			id: 'fund',
			path: '/funds',
			securityId: 'FOUSA00GPG', // Vanguard Institutional Index Fund Institutional Plus Shares (VIIIX)
			securityType: 'FO'
		},
		gmb: {
			id: 'gmb',
			path: '/global-market-barometer'
		},
		index: {
			benchmarkId: SAL_BENCHMARK_ID_MIX,
			contentType: SAL_CONTENT_TYPE_PREMIUM,
			id: 'index',
			path: '/indexes',
			securityId: 'XIUSA00007', // Dow Jones Industrial Average PR USD
			securityType: 'XI'
		},
		pensionFund: {
			benchmarkId: SAL_BENCHMARK_ID_MIX,
			contentType: SAL_CONTENT_TYPE_PREMIUM,
			id: 'pensionFund',
			path: '/pension-funds',
			securityId: 'F00000MA5Z', // Assumption Life Balanced Growth Portfolio B
			securityType: 'FV'
		},
		stock: {
			benchmarkId: SAL_BENCHMARK_ID_MIX,
			contentType: SAL_CONTENT_TYPE_BASIC,
			id: 'stock',
			path: '/stocks',
			securityId: '0P000000GY', // Apple Inc
			securityType: 'EQ'
		}
	}
};

module.exports = { 
	APP,
	SAL_CONTENT_TYPE_BASIC,
	SAL_CONTENT_TYPE_PREMIUM,
	NO_MIP_ANALYSIS_EDITIONS,
	NO_EQSV_SUSTAINABILITY_EDITIONS,
	NO_PARENT_PILLAR_CARDS_EDITIONS
};
